import * as React from "react"
import { NumberFieldSeeker } from "@ui-seeker/core"

import { AppAntSwitch } from "@components"
import { isPreviousComparison, timeToCompare, yearlyComp } from "@signals"


export default function PeriodCompareToggleButton({ ...props }) {
	return <>
		<AppAntSwitch
			trueText="Compare with other period"
			checked={isPreviousComparison.value}
			onChange={e => {
				isPreviousComparison.value = e.target.checked
				if(!e.target.checked) {
					timeToCompare.value = ""
				}
			}}
			{...props}
		/>
		{ isPreviousComparison.value && <AppAntSwitch
			trueText="Per years"
			falseText="Per days"
			checked={yearlyComp.value}
			onChange={e => yearlyComp.value = e.target.checked}
			{...props}
		/> }
	</>
}

export function PeriodCompareInput({ ...props }) {
	return isPreviousComparison.value && <NumberFieldSeeker
		value={timeToCompare.value}
		onChange={e => timeToCompare.value = e.target.value}
		label="Days/Years compare"
		{...props}
	/>
}